import { useEffect, useState } from "react"
import { useGetSaveCartCreditQuery, useGetSaveCartQuery, usePostApplyCreditMutation, usePostPaymentDoneMutation } from "../../store/api/savecartapi"
import { useNavigate, useParams } from "react-router-dom"
import countryList from 'country-list';
import Header from "../../components/Header"
import { IoIosArrowRoundBack } from "react-icons/io"
import { useSelector } from "react-redux"
import Table from "./Component/Table"
import CreditSection from "./Component/CreditSection";
import axios from "axios";
import Summary from "./Component/Summary";
import Loader from "../../components/Loader";


const SaveCartPay = () => {
  const nvg = useNavigate();
  const { orderid } = useParams();
  const [taxable_total, settaxable_total] = useState(0);
  const [mrp_total, setmrp_total] = useState(0);
  const [tableData, settableData] = useState([]);
  const [gst_total, setgst_total] = useState(0);
  const [totalqty, settotalqty] = useState(0);
  const [shippingCharges, setshippingCharges] = useState(0);
  const [checkoutLoader, setcheckoutLoader] = useState(false);
  const [creditGst, setcreditGst] = useState(false);
  const [creditShipping, setcreditShipping] = useState(false);
  const [totalCreditAmount, settotalCreditAmount] = useState(0);
  const [credit_minus_amount, setcredit_minus_amount] = useState(0);
  const [AllowCredit, setAllowCredit] = useState(0);
  const [applyCreditApi] = usePostApplyCreditMutation()
  const [paymentdoneApi] = usePostPaymentDoneMutation()
  const { data: SaveCartData, isLoading: saveCartLoader } = useGetSaveCartQuery({ id: orderid })
  const { data: creditData, isLoading: creditLoading } = useGetSaveCartCreditQuery({ id: orderid });
  const { bgColor, textColor } = useSelector((state) => state.theam);
  const [is_Credit_Applied, setis_Credit_Applied] = useState(false);

  const StatusReturn = (s) =>{
   if(s == "Saved_Cart_Approved"){
    return "Cart Updated";
   }
   if(s == "Saved_Cart"){
    return "Saved Cart";
   }
   if(s == "Saved_Cart_Rejected"){
    return "Saved Cart Rejected";
   }
   if(s == "Saved_Cart_Order_Created"){
    return "Confirmed";
   }
   return s;
  }

  const creditUsed = (shipAmount, TotalAmount, gstAmount, taxableAmount, creditAmount, gst, shipping) => {

    if (creditAmount > (TotalAmount + shipAmount)) {
      if (gst == true && shipping == true) {
        return TotalAmount + shipAmount;
      }
      if (gst == true && shipping == false) {
        return TotalAmount;
      }
      if (gst == false && shipping == true) {
        return (TotalAmount + shipAmount) - gstAmount;
      }
      if (gst == false && shipping == false) {
        return taxableAmount;
      }

    } else {
      if (gst == true && shipping == true) {
        return creditAmount;
      }
      if (gst == false && shipping == true) {
        if ((taxableAmount + shipAmount) > creditAmount) {
          return creditAmount;
        } else {
          return taxableAmount + shipping;
        }
      }
      if (gst == true && shipping == false) {
        if ((taxableAmount + gstAmount) > creditAmount) {
          return creditAmount;
        } else {
          return taxableAmount + gstAmount;
        }
      }
      if (gst == false && shipping == false) {
        if (taxableAmount > creditAmount) {
          return creditAmount;
        } else {
          return taxableAmount;
        }
      }
    }

  }

  const applycredit = async () => {
    try {
      const response = await applyCreditApi({ id: orderid,body:{'shipping_charge':shippingCharges} });
      if (response.data.msg == "credit added succesfully") {
        setis_Credit_Applied(true);
      }
    } catch (error) {
      console.log("error check", error);
    }
  }

  const payment = async () => {
   const totalprice = (parseInt((taxable_total + gst_total + shippingCharges)) - (is_Credit_Applied ? parseInt(AllowCredit) : 0));
   if(totalprice == 0 || totalprice < 0 || (totalprice >= 0 && totalprice <= 1)){
     return orderrequest("","fullyCredit");
   }
    var options = {
      key: process.env.REACT_APP_PAYMENT_KEY,
      key_secret: process.env.REACT_APP_PAYMENT_KEY_SECRET,
      amount: Number(parseFloat(((taxable_total + gst_total + shippingCharges) - (is_Credit_Applied ? AllowCredit : 0))) * 100).toFixed(0) > 0 ? Number(parseFloat(((taxable_total + gst_total + shippingCharges) - (is_Credit_Applied ? AllowCredit : 0))) * 100).toFixed(0) : 0,
      currency: "INR",
      order_receipt: "order_oneupshop",
      name: "OneUpShop",
      description: "for testing purpose",
      handler: async function (response) {
        const paymentId = response.razorpay_payment_id;
        try {
          orderrequest(paymentId)
        } catch (error) {
        }
      },

      theme: {
        color: `#${bgColor}`,
      },
      modal: {
        ondismiss: function () { }
      },
    };
    var pay = new window.Razorpay(options);
    pay.open();

  }

  const orderrequest = async (id,paymentstatus="") => {
    setcheckoutLoader(true);
    try {
      const formdata = new FormData();
      formdata.append("orderid", orderid);
      formdata.append("total_amount", ((taxable_total + gst_total + shippingCharges) - (is_Credit_Applied ? AllowCredit : 0)));
      formdata.append("shippingaddress", JSON.stringify(SaveCartData.shipping_address));
      formdata.append("payment_id", id);
      formdata.append("shipping_price", parseInt(shippingCharges));
      formdata.append("billingaddress", JSON.stringify(SaveCartData.billing_address));
      formdata.append("status", "SUCCESS");
      if(is_Credit_Applied){
        formdata.append("credit", parseInt(AllowCredit));
        if(((taxable_total + gst_total + shippingCharges) - (is_Credit_Applied ? AllowCredit : 0)) > 0){
           if(paymentstatus == "fullyCredit"){
             formdata.append("payment_type", 'Credit');
            }else{
             formdata.append("payment_type", 'Custom');
           }
        }else{
          formdata.append("payment_type", 'Credit');
        }
      }else{
        formdata.append("payment_type", 'razorpay');
      }
      
      const response = await paymentdoneApi(formdata);
      setcheckoutLoader(false);
      if (response.data.message == "Order successfully!") {
        nvg('/save-cart-list')
      }

    } catch (error) {
      setcheckoutLoader(false);
      console.log("error is here", error);
    }
  };



  useEffect(() => {
    if (!saveCartLoader && !creditLoading) {
      const product_list = SaveCartData.product_deatils;
      const totalgst = product_list.reduce((total, item) => total + item.gst_tax_amount * item.quantity, 0);
      const totalbase = product_list.reduce((total, item) => total + item.base_price * item.quantity, 0);
      const totalmrp = product_list.reduce((total, item) => total + ((item.base_price + item.gst_tax_amount) * item.quantity), 0);
      settableData(product_list);
      setshippingCharges(SaveCartData.shiping_charge);
      settotalqty(product_list.reduce((acc, product) => acc + 1 * product.quantity, 0));
      setgst_total(totalgst); 
      settaxable_total(totalbase); 
      setmrp_total(totalmrp);

      if (creditData.expired === false) {
        settotalCreditAmount(creditData.amount);
        setcredit_minus_amount(creditData.minus_amount)
        setcreditShipping(creditData.shipping_value)
        setcreditGst(creditData.GST)
        const creditvalue = creditUsed(
          SaveCartData.shiping_charge,
          (totalgst + totalbase),
          totalgst,
          totalbase,
          creditData.amount,
          creditData.GST,
          creditData.shipping_value
        );
        setAllowCredit(creditvalue.toFixed(0));
        console.log("check response of shipAmount 3344333",totalmrp,totalbase,totalgst);

      }

    }
  }, [SaveCartData, creditData, saveCartLoader, creditLoading])

  return (
    saveCartLoader || creditLoading || checkoutLoader ? <div className="d-flex justify-content-center align-items-center" style={{height:'98vh'}}> <Loader /> </div> : <>
      <Header />


      <div className="breadcrumb-main marginfromtop" style={{ background: "#fff" }}>
        <div className="container m-0">
          <div className="row">
            <div className="col">
              <div className="breadcrumb-contain">
                <div>
                  <ul>
                    <li><a href="/home">home</a></li>
                    <li>{`>`}</li>
                    <li><a href="javascript:void(0)">Save Cart Detail</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="section-big-py-space b-g-light ">
        <div className="container-fluid d-flex justify-content-center">
          <div className="row justify-content-center definewidth" >
            <div className="col-md-8">

              <div className="table-responsive hist" style={{ borderRadius: "6px" }}>
                <h5 style={{ padding: '9px 9px', fontWeight: 400, fontSize: 14, paddingBottom: '20px', cursor: 'pointer' }} onClick={() => { nvg("/save-cart-list") }}><IoIosArrowRoundBack size={24} style={{ color: `#${textColor}` }}
                />
                  Back to list</h5>
                <div className="">
                  <h4 className="Orderstatus addmedia" style={{ width: '100%', display: 'flex', justifyContent: 'space-between', padding: '0px 9px', fontWeight: 700, fontSize: "13px", paddingBottom: '20px', paddingTop: '10px' }}>
                  Cart Id: {orderid}    <span> {new Date(SaveCartData.order_date.split('Time')[0]).toLocaleDateString('en-GB', { hour: 'numeric', minute: 'numeric' })}</span>  
                   <span style={{ display: 'block', color: 'black', textTransform: 'capitalize' }}>Cart Status: <img src={`${process.env.REACT_APP_API_PUBLIC_URL}/images/icon/success.png`} alt="404" /> 
                   {StatusReturn(SaveCartData.order_status)}
                   </span>
                   </h4></div>

                <Table
                  ApiData={tableData}
                  fullData={SaveCartData}
                  Count={{
                    qty: totalqty,
                    gst: gst_total,
                    taxable: taxable_total,
                    mrp: mrp_total
                  }}
                />

                <br />
              </div>


              {SaveCartData.payment_mode == "Quotation_Shared" || SaveCartData.payment_mode == "Saved_Cart_Approved" ? (
                <CreditSection
                  tableData={{
                    AllowCredit,
                    gst: creditGst,
                    shipping: creditShipping,
                    total: totalCreditAmount,
                    shipAmount: shippingCharges,
                    mamount: credit_minus_amount,
                  }}
                  applycredit={applycredit}
                  orderid={orderid}
                />) : ''}


            </div>




            <div className=" col-lg-4 col-md-4 mt-lg-0 mt-md-0 mt-sm-3 ">

              <div
                className="py-0"
                style={{
                  position: "relative",
                  top: "0px",
                  background: "#ffff",
                  borderRadius: 6,
                  marginBottom: "10px",
                }}
              >
                <div
                  className="firstrow px-4 d-flex justify-content-between"
                  style={{ padding: "5px 0px", paddingLeft: "20px" }}
                >
                  <h4
                    style={{
                      fontWeight: 700,
                    }}
                    className="titlesizes"
                  >
                    Delivery Address
                  </h4>
                </div>
                <div className="py-2 mt-lg-0 mt-md-3 mt-3" style={{ background: "#ffff", borderRadius: 6 }}>
                  <div className="px-4" >

                    <h4 style={{ fontSize: '14px' }}>Billing Address</h4>
                    <p style={{ color: '#2B2A29', fontSize: '12px' }}>{SaveCartData.billing_address.first_name} {SaveCartData.billing_address.last_name}</p>
                    <p style={{ fontSize: '12px' }}> {SaveCartData.billing_address.line1}, {SaveCartData.billing_address.line2},  {countryList.getName(SaveCartData.billing_address.country)},{SaveCartData.billing_address.state}, {SaveCartData.billing_address.line4}, {SaveCartData.billing_address.postcode} <br />
                    </p>
                    <p className="" style={{ fontSize: '12px' }}>
                      Mobile:{" "}
                      <span className="number2" style={{ color: '#2B2A29' }}>
                        {SaveCartData.billing_address.phone_number}
                      </span>
                    </p>
                    <p className="" style={{ fontSize: '12px' }}>
                      Email ID:{" "}
                      <span className="number2" style={{ color: '#2B2A29' }} >
                        {SaveCartData.billing_address.email}

                      </span>
                    </p>
                  </div>
                  <div className="px-4" style={{}}>
                    <br />
                    <h4 style={{ fontSize: '14px' }}>Delivery Address</h4>
                    <p style={{ color: '#2B2A29', fontSize: '12px' }}>{SaveCartData.shipping_address.first_name} {SaveCartData.shipping_address.last_name}</p>
                    <p style={{ fontSize: '12px' }}> {SaveCartData.shipping_address.line1}, {SaveCartData.shipping_address.line2},  {countryList.getName(SaveCartData.shipping_address.country)},{SaveCartData.shipping_address.state}, {SaveCartData.shipping_address.line4}, {SaveCartData.shipping_address.postcode} <br />
                    </p>
                    <p className="" style={{ fontSize: '12px' }}>
                      Mobile:{" "}
                      <span className="number2" style={{ color: '#2B2A29' }}>
                        {SaveCartData.shipping_address.phone_number}
                      </span>
                    </p>
                    <p className="" style={{ fontSize: '12px' }}>
                      Email ID:{" "}
                      <span className="number2" style={{ color: '#2B2A29' }} >
                        {SaveCartData.shipping_address.email}

                      </span>
                    </p>
                  </div>
                </div>

              </div>


              <Summary
                Count={{
                  totalqty,
                  gst_total,
                  taxable_total,
                  shippingCharges,
                  is_Credit_Applied,
                  AllowCredit,
                  creditAmount:SaveCartData?.credit
                }} />



              <div
                className="py-2 mt-lg-0 mt-md-3 mt-3"
                style={{ background: "#ffff", borderRadius: 6, display: SaveCartData.payment_mode == "Quotation_Shared" || SaveCartData.payment_mode == "Saved_Cart_Approved" ? "block" : "none" }}
              >


                <div className="px-4">
                  <button style={{
                    border: "none",
                    outline: "none",
                    backgroundColor: `#${bgColor}`,
                    padding: "7px 0px",
                    color: "white",
                    width: "100%",
                    fontWeight: 600,
                  }}
                    onClick={() => { payment() }}
                  >
                    CONFIRM ORDER
                  </button>

                </div>

              </div>


            </div>
          </div>
        </div>
      </section>




    </>
  )
}

export default SaveCartPay